import type { ReactNode } from 'react';

export interface TableContainerProps {
  children: ReactNode;
  className?: string;
  dataTestId?: string;
}

export const Table = ({
  children,
  className = 'border-soFresh-140 overflow-hidden rounded-lg border p-0',
  dataTestId = ''
}: TableContainerProps) => {
  return (
    <div className={className} data-testid={dataTestId}>
      {children}
    </div>
  );
};
